module.exports = __webpack_public_path__ + "img/edit-icon.c4a18e05.svg";